import { getErrorResponse } from 'legacy/lut/functions'
import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpCancel, HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'

import { ISPJBPDataResponse } from '../../services/models/ISPJBPDataResponse'

export const fetchEltPlanningSettings = async <T>(
  uid: string,
  cancelObject?: HttpCancel
): Promise<ISPJBPDataResponse<T>> => {
  let response

  const url = proxy('/webservice/621/sp/v4/spJBPELTPlanningSettings/call')

  const payload = {
    'p.UID': uid,
  }

  const { app } = appGetState()
  const [accessToken] = getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  try {
    response = await Rest.post({ url, payload, cancelObject, headers })
  } catch (e: any) {
    const errorMessage = `Failed to request ELT Planning Settings by UID '${uid}'`
    Logger.log(`${errorMessage}: ${e.message}`)
    response = getErrorResponse<ISPJBPDataResponse<T>>(e.message || errorMessage, {
      Total: -1,
      Data: [],
      Errors: errorMessage,
    })
  }

  return response
}
